<template src="./quiz-landing.html"></template>
<script>
import appHeader from "./../../../shared-module/components/app-header/app-header.vue";
import createQuiz from "./../create-quiz/create-quiz";
import addParagraph from "./../edit-quiz-questions/add-paragraph/add-paragraph";
import quizService from "../../services/quiz-service";
import reportService from "../../services/report-service";
import storageService from "../../services/storage-service";
import ClickOutside from "vue-click-outside";
import { exportToCSV } from "../../services/csvService";
import omrService from "../../services/omr-service";
var chevronListBox;
var createQuizPopup = false;
var reportsPopup = false;
var sort_By = "created_at";
var order_By = false;
var reportsArray = [
  { totalCount: 0, questions: [] },
  { totalCount: 0, questions: [] },
  { totalCount: 0, questions: [] },
  { totalCount: 0, questions: [] },
  { totalCount: 0, questions: [] },
];
var quizzes;
var archivedView = false;
var versionHistory = false;
export default {
  name: "app-quiz-landing",
  components: {
    "app-create-quiz": createQuiz,
    "app-add-paragraph": addParagraph,
    "app-header": appHeader,
  },
  directives: {
    ClickOutside,
  },
  data: () => {
    return {
      publish_unpublish_check: 0,
      check_archive: 0,
      chevronListBox,
      reportsPopup,
      reportsArray,
      createQuizPopup,
      sort_By,
      order_By,
      quizzes: [],
      archivedView,
      pageNo: 1,
      // pageRange: [],
      versionHistory,
      searchFlag: true,
      searchOtherFlag: false,
      quizName: "",
      searchResults: "",
      courseName: "",
      moduleName: "",
      quizDiv: "",
      currentQuiz: 0,
      quizId: "",
      // currPage: 1,
      quizData: "",
      currentVersion: 0,
      isArchived: false,
      selectedQuizzes: [],
      selectionFlag: false,
      condition: "",
      versions: "",
      nextPage: false,
      previousPage: false,
      pages: "",
      page: "",
      nextPageNo: "",
      countUnPublishQuiz: "",
      countQuiz: "",
      hasPrevpage: false,
      previousPageNo: "",
      loadMore: false,
      dataFetched: false,
      isFirst: true,
      isNext: true,
      val: "",
      isfullQuiz: false,
      versionID: "",
      qType: "",
      isQuiz_loading: false,
      isLoadingData: false, // New flag to prevent multiple simultaneous API calls
      filterAndSort: {
        filters: {
          is_publish: true,
          is_archived: false,
          quiz_type: "all",
        },
        sort: {
          sortBy: "created_at",
          sortOrder: -1,
        },
        search: {
          key: "",
          value: "",
          search: false,
        },
        pagination: {
          page: 1,
          perPage: 50,
        },
      },
      keepFilters: false,
      _isMounted: false,
      _initialLoadComplete: false, // Flag to track initial load
      isEditQuizLoading: false,
      quizPrefetched: false,
    };
  },

  watch: {
    filterAndSort: {
      handler(newVal) {
        if (this.keepFilters && this._isMounted && !this.isLoadingData) {
          localStorage.setItem('quizFilterAndSort', JSON.stringify(newVal));
        }
      },
      deep: true
    }
  },
  async created() {
    // Clear any existing data on page refresh
    if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD) {
      this.quizzes = [];
    }
    
    const instructorId = storageService.get("uid");
    
    // Check if we should keep filters from URL parameter
    const keepFiltersParam = this.$route.query.keepFilters;
    this.keepFilters = keepFiltersParam === 'true';
    
    // If we should keep filters, try to restore them from localStorage
    let stateRestored = false;
    if (this.keepFilters) {
      stateRestored = this.restoreFilterState();
    } else {
      // If we shouldn't keep filters, clear localStorage and reset state
      localStorage.removeItem('quizFilterAndSort');
      this.resetToDefaultState();
    }
    
    if(instructorId) {
      this.getUnPublishedCount();
      this.getPublishedCount();
      
      // Load quizzes - use a single method to avoid duplicates
      await this.loadQuizzes(true);
      this._initialLoadComplete = true;
    }
    
    if (this.$route.query.editType && this.$route.query.editType === "back") {
      let quizEdit = await quizService.getQuizById(
        this.$route.query.EditquizID
      );
      this.createQuizPopupHandler(quizEdit.data.data.quiz, { skipFetch: true });
    }
  },
  methods: {
    quizResultsRoute(quiz) {
      const id = quiz && (quiz._id || quiz.id);
      if (!id) return { path: "/quiz/quiz-landing" };
      if (quiz.quiz_type === "omr") {
        return { path: "/quiz/omr-quiz-results", query: { quizId: id } };
      }
      return { path: "/quiz/quiz-results", query: { quizId: id } };
    },
     updateUrlWithKeepFilters() {
       if (this.$route.query.keepFilters !== 'true') {
         this.$router.replace({ 
           path: this.$route.path, 
           query: { 
             ...this.$route.query, 
             keepFilters: 'true' 
           } 
         }).catch(err => {
           if (err.name !== 'NavigationDuplicated') {
             throw err;
           }
         });
       }
       this.keepFilters = true;
     },
     
     updateUrlWithoutKeepFilters() {
       if (this.$route.query.keepFilters) {
         const query = { ...this.$route.query };
         delete query.keepFilters;
         
         this.$router.replace({ 
           path: this.$route.path, 
           query 
         }).catch(err => {
           if (err.name !== 'NavigationDuplicated') {
             throw err;
           }
         });
       }
       this.keepFilters = false;
     },

     restoreFilterState() {
      const savedState = localStorage.getItem('quizFilterAndSort');
      if (savedState) {
        try {
          const parsedState = JSON.parse(savedState);
          this.filterAndSort = parsedState;
          
          // Ensure pagination is reset
          this.filterAndSort.pagination.page = 1;
          
          // Restore UI state based on saved filters
          this.publish_unpublish_check = this.filterAndSort.filters.is_publish ? 0 : 1;
          this.check_archive = this.filterAndSort.filters.is_archived ? 1 : 0;
          
          // Restore search fields
          if (this.filterAndSort.search.search) {
            if (this.filterAndSort.search.key === 'quiz') {
              this.quizName = this.filterAndSort.search.value;
            } else if (this.filterAndSort.search.key === 'course') {
              this.courseName = this.filterAndSort.search.value;
            } else if (this.filterAndSort.search.key === 'module') {
              this.moduleName = this.filterAndSort.search.value;
            }
          }
          return true; // State was restored
        } catch (e) {
          console.error('Error restoring filter state:', e);
          // If there's an error, use default state
          localStorage.removeItem('quizFilterAndSort');
        }
      }
      return false; // No state was restored
    },
    resetToDefaultState() {
      this.filterAndSort = {
        filters: {
          is_publish: true,
          is_archived: false,
          quiz_type: "all",
        },
        sort: {
          sortBy: "created_at",
          sortOrder: -1,
        },
        search: {
          key: "",
          value: "",
          search: false,
        },
        pagination: {
          page: 1,
          perPage: 50,
        },
      };
      this.publish_unpublish_check = 0;
      this.check_archive = 0;
      this.quizName = "";
      this.courseName = "";
      this.moduleName = "";
    },
    async loadQuizzes(resetList = false, showLoader = false) {
      // Prevent multiple simultaneous API calls
      if (this.isLoadingData) {
        console.log('API call already in progress, skipping...');
        return;
      }
      
      this.isLoadingData = true;
      
      try {
        if (showLoader) {
          this.isQuiz_loading = true;
        }
        
        if(this.filterAndSort.filters.is_archived == false){
          this.check_archive = 0;
        } else {
          this.check_archive = 1;
        }
        
        const instructorId = storageService.get("uid");

        // Reset pagination to first page if resetList is true
        if (resetList) {
          this.filterAndSort.pagination.page = 1;
        }
        
        const response = await quizService.getFilteredAndSortQuizes(
          this.filterAndSort,
          instructorId
        );
        
        if (response && response.data) {
          this.isNext = response.data.hasNextPage;
          
          if (resetList) {
            // Replace the entire list
            this.quizzes = [...response.data.docs]; // Create a new array to avoid reference issues
          } else {
            // Append to existing list (for pagination)
            this.quizzes = [...this.quizzes, ...response.data.docs]; // Create a new array to avoid reference issues
          }
          
          // Only increment page after successful response
          this.filterAndSort.pagination.page++;
        }
      } catch (error) {
        this.isNext = false;
        console.error('Error loading quizzes:', error);
      } finally {
        if (showLoader) {
          this.isQuiz_loading = false;
        }
        this.isLoadingData = false;
      }
    },
    async filterToggle(toggle, value) {
      if(toggle == 'is_publish' && value == false){
         this.publish_unpublish_check = 1;
      }
      if(toggle == 'is_publish' && value == true){
        this.publish_unpublish_check = 0;
      }
      
      this.filterAndSort.filters[toggle] = value;
      this.updateUrlWithKeepFilters();
      await this.filterAndSortQuiz(true);
    },
    async sortToggle(toggle) {
      if (this.filterAndSort.sort.sortBy === toggle)
        this.filterAndSort.sort.sortOrder =
          this.filterAndSort.sort.sortOrder === 1 ? -1 : 1;
      else {
        this.filterAndSort.sort.sortBy = toggle;
        this.filterAndSort.sort.sortOrder = -1;
      }
      this.updateUrlWithKeepFilters();
      await this.filterAndSortQuiz(true);
    },
    async filterAndSortQuiz(first) {
      // Clear the quizzes array before loading new data if first is true
      if (first) {
        this.quizzes = [];
      }
      await this.loadQuizzes(first, true);
    },
    async DuplicateQuiz(id) {
      try {
        let quiz_id = id;
        let resp;
        resp = await quizService.duplicateQuiz(quiz_id);
        if (quiz_id) {
          this.closePopUp();
          this.$toast("Quiz Duplicated");
          this.$router.go();
        }
      } catch (error) {
        this.$toast.error("Error Quiz Not Duplicated");
      }
    },
    async getPublishedCount() {
      try {
        const instructorId = storageService.get("uid");
        let response = await quizService.getPublishedCount(instructorId);
        this.countQuiz = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getUnPublishedCount() {
      try {
        const instructorId = storageService.get("uid");
        let response = await quizService.getUnPublishedCount(instructorId);
        this.countUnPublishQuiz = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async exportCsv() {
      try {
        let data = { quiz_id: this.selectedQuizzes };
        if (this.selectedQuizzes == "") {
          this.$toast("plz select a quiz first");
        }
        data.quiz_id.forEach(async (val) => {
          var idd = "";
          idd = val;
          let resp;
          resp = await quizService.downloadCsv(idd);
          if (resp.data.status === "success") {
            exportToCSV(resp.data.data.csv, idd);
          }
        });
      } catch (error) {
        this.$toast.error("Error while file download");
      }
    },
    async downloadCsvFile(id) {
      try {
        let quiz_id = id;
        let resp;
        resp = await quizService.downloadCsv(quiz_id);
        if (resp.data.status === "success") {
          exportToCSV(resp.data.data.csv, id);
        }
      } catch (error) {
        this.$toast.error("Error in file download");
      }
    },
    async downloadOmrJsonFile(quizId, quizName) {
      try {
        const response = await omrService.exportQuizJson(quizId);
        const blob = new Blob([JSON.stringify(response.data, null, 2)], { type: "application/json" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${quizName || "omr-quiz"}.json`.replace(/[^a-z0-9-_.]+/gi, "-");
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error("Error in OMR JSON download");
      }
    },
    async getShareableLink(id, quiz, type) {
      try {
        let quiz_id = id;
        let res;
        let link;
        if (type === "pop") {
          link = `${process.env.VUE_APP_SHARE_ABLE_LINK_POP}course/${quiz.module.index_url}/${quiz.video.module_no}/${quiz.video.id}?courseIndexUrl=${quiz.course.index_url}`;
        } else {
          res = await quizService.getShareableLink(quiz_id);
          link =
            process.env.VUE_APP_SHARE_ABLE_LINK + res.data.data.session._id;
        }
        navigator.clipboard.writeText(link);
        if (link) {
          this.closePopUp();
          this.$toast("Link Coppied");
        }
      } catch (error) {
        this.$toast.error("Error Link Not Coppied");
      }
    },
    async onScroll() {
      if (this.isNext && !this.isLoadingData) {
        await this.loadQuizzes(false, false);
      }
    },
    async sortt(condition, sort_By, order_By) {
      if (this.val === "GetPublish") {
        this.getpublishQuizzes(condition, sort_By, order_By);
      } else if (this.val === "getunpublish") {
        this.getUnpublishQuizzes(condition, sort_By, order_By);
      } else if (this.val === "getquizzes") {
        this.getQuizzes(condition, sort_By, order_By);
      } else {
        this.getpublishQuizzes(condition, sort_By, order_By);
      }
      this.updateUrlWithKeepFilters();
    },
    async QuizType(isFirst) {
      this.condition = "quizbytype";
      var test = document.getElementById("select").value;
      if (test == "SELECT") {
        this.getpublishQuizzes(true, this.sort_By, this.order_By);
      } else {
        const instructorId = storageService.get("uid");
        if (isFirst) {
          this.currPage = 1;
        }
        let data = {
          type: test,
          instructor_id: instructorId,
          page: this.currPage,
          perPage: 50,
        };
        let response;
        response = await quizService.getQuizByType(data);
        if (response) {
          this.pageNo++;
          if (!response.data.hasNextPage) {
            this.isNext = false;
          }
          if (isFirst) {
            this.isNext = !response.data.hasNextPage ? false : true;
            this.quizzes = [...response.data.docs]; // Create a new array
          } else {
            this.quizzes = [...this.quizzes, ...response.data.docs]; // Create a new array
          }
        }
      }
      this.updateUrlWithKeepFilters();
    },
    async getpublishQuizzes(isFirst, sort, order) {
      this.val = "GetPublish";
      this.condition = "GetPublish";
      if (isFirst) {
        this.currPage = 1;
      }
      const instructorId = storageService.get("uid");
      let response;
      let data = {
        instructor_id: instructorId,
        page: this.currPage,
        perPage: 50,
      };
      this.order_By = order;
      if (sort != undefined) {
        this.condition = "GetPublish";
        this.sort_By = sort;
        data = {
          instructor_id: instructorId,
          page: this.currPage,
          perPage: 50,
          sortBy: sort,
          orderBy: order,
        };
      }
      response = await quizService.getPublishQuiz(data);
      if (response) {
        this.pageNo++;
        if (!response.data.hasNextPage) {
          this.isNext = false;
        }
        if (isFirst) {
          this.isNext = !response.data.hasNextPage ? false : true;
          this.quizzes = [...response.data.docs]; // Create a new array
        } else {
          this.quizzes = [...this.quizzes, ...response.data.docs]; // Create a new array
        }
      }
      this.updateUrlWithKeepFilters();
    },
    async getUnpublishQuizzes(isFirst, sort, order) {
      this.val = "getunpublish";
      this.condition = "getunpublish";
      if (isFirst) {
        this.isNext = true;
        this.currPage = 1;
      }
      const instructorId = storageService.get("uid");
      let response;
      let data = {
        instructor_id: instructorId,
        page: this.currPage,
        perPage: 50,
      };
      this.order_By = order;
      if (sort != undefined) {
        this.condition = "getunpublish";
        this.sort_By = sort;
        data = {
          instructor_id: instructorId,
          page: this.currPage,
          perPage: 50,
          sortBy: sort,
          orderBy: order,
        };
      }

      response = await quizService.getUnPublishQuiz(data);
      if (response) {
        this.pageNo++;
        if (!response.data.hasNextPage) {
          this.isNext = false;
        }
        if (isFirst) {
          this.quizzes = [...response.data.docs]; // Create a new array
        } else {
          this.quizzes = [...this.quizzes, ...response.data.docs]; // Create a new array
        }
      }
      this.updateUrlWithKeepFilters();
    },
    getQuizzesPaginate(page) {
      this.currPage = page;
      this.filterAndSort.pagination.page = this.currPage;
      this.filterAndSortQuiz();
      this.pagesToShow();
      this.updateUrlWithKeepFilters();
    },
    pagesToShow() {
      let first = 0, last = 7, mid = 3;
      const total = this.pageRange.length;
      if(total > 7) {
        if(this.currPage > 4 && this.currPage < total - 2) {
          first = this.currPage - 4;
          last = this.currPage + 3;
        } else if (this.currPage > total - 3) {
          first = total - last;
          last = total;
        }
      }
      
      const pages = this.pageRange.slice(first, last);
      return pages;
    },
    async getQuizzes(isFirst, sort, order) {
      this.condition = "getquizzes";
      this.val = "getquizzes";
      const instructorId = storageService.get("uid");
      if (isFirst) {
        this.currPage = 1;
      }
      let response;
      let data = {
        instructor_id: instructorId,
        page: this.currPage,
        perPage: 50,
      };
      this.order_By = order;
      if (sort != undefined) {
        this.condition = "getquizzes";
        this.sort_By = sort;
        data = {
          instructor_id: instructorId,
          page: this.currPage,
          perPage: 50,
          sortBy: sort,
          orderBy: order,
        };
      }
      if (this.archivedView) {
        try {
          response = await quizService.getArchivedQuizzesByInstructorId(data);
          if (response) {
            if (!response.data.data.quizzes.hasNextPage) {
              this.isNext = false;
            }
            if (isFirst) {
              this.quizzes = [...response.data.data.quizzes.docs]; // Create a new array
            } else {
              this.quizzes = [...this.quizzes, ...response.data.data.quizzes.docs]; // Create a new array
            }
          }
        } catch (error) {
          this.quizzes = [];
        }
      } else {
        response = await quizService.getQuizzesByInstructorId(data);
        if (response) {
          if (!response.data.data.quizzes.hasNextPage) {
            this.isNext = false;
          }
          if (isFirst) {
            this.isNext = !response.data.data.quizzes.hasNextPage
              ? false
              : true;
            this.quizzes = [...response.data.data.quizzes.docs]; // Create a new array
          } else {
            this.quizzes = [...this.quizzes, ...response.data.data.quizzes.docs]; // Create a new array
          }

          this.nextPage = response.data.data.quizzes.hasNextPage;
          this.previousPage = response.data.data.quizzes.hasPrevPage;
          this.pages = response.data.data.quizzes.totalPages;
          this.currentPage = response.data.data.quizzes.page;
          this.nextPageNo = response.data.data.quizzes.nextPage;
          this.previousPageNo = response.data.data.quizzes.prevPage;
          this.pages++;
        }
      }
      this.pageNo++;
      this.updateUrlWithKeepFilters();
    },

    myFunction(id) {
      this.quizId = id;
      this.chevronListBoxHandler(this.quizId);
    },
    chevronListBoxHandler(id) {
      this.quizId = id;
      this.currentQuiz = id;
      this.chevronListBox = !this.chevronListBox;
    },
    closePopUp() {
      this.chevronListBox = false;
      this.versionHistory = false;
    },
    versionShow(id) {
      this.versions = "";
      this.quizId = id;
      this.versionBoxHandler(this.quizId);
      this.getVersions(this.quizId);
    },
    versionBoxHandler(id) {
      this.currentVersion = id;
      this.versionHistory = !versionHistory;
    },
    async reportsPopupHandler(quiz) {
      window.open(`${process.env.VUE_APP_REPORTING_PANEL}quiz-issues`, '_blank')
    },
    async createQuizPopupHandler(quiz, options = {}) {
      if (quiz && (quiz._id || quiz.id)) {
        this.isEditQuizLoading = true;
        this.quizPrefetched = false;
        this.quizData = quiz;
        this.createQuizPopup = true;
        try {
          if (!options.skipFetch) {
            const quizId = quiz._id || quiz.id;
            const isOmr = quiz.quiz_type === "omr";
            const response = await quizService.getQuizUpdatedVersion(
              quizId,
              isOmr ? { light: true } : {}
            );
            if (response && response.data && response.data.data && response.data.data.quiz) {
              this.quizData = response.data.data.quiz;
            }
          }
          this.quizPrefetched = true;
        } catch (error) {
          console.error(error);
          this.$toast.error("Failed to load quiz details");
        } finally {
          this.isEditQuizLoading = false;
        }
        return;
      }
      this.quizPrefetched = false;
      this.isEditQuizLoading = false;
      this.quizData = quiz;
      this.createQuizPopup = true;
    },
    popupClose() {
      this.reportsPopup = false;
      this.createQuizPopup = false;
      this.isEditQuizLoading = false;
      this.quizPrefetched = false;
    },
    popCpTop(){
      this.$refs.popCpTop.scrollTop = 0;
    },
    archiveUnarchive(isFirst) {
      this.archivedView = !this.archivedView;
      this.filterAndSort.filters.is_archived = this.archivedView;
      this.updateUrlWithKeepFilters();
      this.getQuizzes(isFirst);
    },
    getSearchFlag(args, clearAll = false) {
      // Prevent multiple calls
      if (this.isLoadingData) return;
      
      // Reset search fields
      this.quizName = "";
      this.courseName = "";
      this.moduleName = "";
      
      // Clear search state
      this.filterAndSort.search.key = "";
      this.filterAndSort.search.value = "";
      this.filterAndSort.search.search = false;
      
      // If clearAll is true or args is not 1, reset all filters
      if (clearAll || args !== 1) {
        // Reset to default state
        this.resetToDefaultState();
        
        // Clear localStorage and remove keepFilters parameter
        localStorage.removeItem('quizFilterAndSort');
        this.keepFilters = false;
        this.updateUrlWithoutKeepFilters();
      } else {
        // Just update URL with keepFilters parameter
        this.updateUrlWithKeepFilters();
      }
      
      // Clear quizzes array to prevent duplicates
      this.quizzes = [];
      
      // Reload quizzes with updated filters
      this.loadQuizzes(true, true);
    },

    toggleFilterPersistence() {
      this.keepFilters = !this.keepFilters;
      if (this.keepFilters) {
        this.updateUrlWithKeepFilters();
      } else {
        this.updateUrlWithoutKeepFilters();
      }
    },

    async searchQuizzes(type) {
      // Prevent multiple calls
      if (this.isLoadingData) return;
      
      this.isQuiz_loading = true;
      if (type == "quiz") {
        this.filterAndSort.search.value = this.quizName;
      } else if (type == "course") {
        this.filterAndSort.search.value = this.courseName;
      } else if (type == "module") {
        this.filterAndSort.search.value = this.moduleName;
      }
      if (!this.filterAndSort.search.value.trim()) {
        this.isQuiz_loading = false;
        return false;
      }
      this.filterAndSort.search.key = type;
      this.filterAndSort.search.search = true;
      this.updateUrlWithKeepFilters();
      
      // Clear quizzes array to prevent duplicates
      this.quizzes = [];
      
      await this.filterAndSortQuiz(true);
    },

    async unpublishQuiz(flag, id) {
      try {
        if (flag) {
          let data = { quiz_id: [id] };
          let response = await quizService.unpublishQuiz(data);
          if (response) {
            this.closePopUp();
            this.$toast.success("Quiz unpublished");
          }
        } else {
          let data = { quiz_id: this.selectedQuizzes };
          let response = await quizService.unpublishQuiz(data);
          if (response) {
            this.$toast.success("Quiz unpublished");
          }
        }
      } catch (error) {
        this.$toast.error("Please select a quiz");
      }
      this.selectedQuizzes = [];
      this.updateUrlWithKeepFilters();
      this.getpublishQuizzes(true);
    },

    async archiveQuizid(id) {
      this.selectedQuizzes = [id.toString()];
      this.archiveQuiz();
    },
    async archiveQuiz(val) {
      try {
        if (val === true) {
          let data = { quiz_id: this.selectedQuizzes };
          let response = await quizService.archiveQuiz(data);
          if (response) {
            this.closePopUp();
            this.$toast.success("Archived Selected Quiz");
          }
        } else {
          let data = { quiz_id: this.selectedQuizzes };
          let response = await quizService.unarchiveQuiz(data);
          if (response) {
            this.closePopUp();
            this.$toast.success("Unarchived Selected Quiz");
          }
        }
      } catch (error) {
        this.$toast.error("Please select a quiz");
      }
      this.selectedQuizzes = [];
      this.updateUrlWithKeepFilters();
      this.getQuizzes(true);
    },
    selectAll() {
      this.selectedQuizzes = [];
      if (!this.selectionFlag) {
        for (let i in this.quizzes) {
          this.selectedQuizzes.push(this.quizzes[i].id);
        }
      }
    },
    async getVersions(id) {
      try {
        if (id) {
          let body = { quiz_id: id };
          let response = await quizService.getVersion(body);
          if (response.data.data.versionHistory) {
            this.versions = response.data.data.versionHistory;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    pageNext(incomingPage) {
      this.pageNo = incomingPage;
      this.updateUrlWithKeepFilters();
      this.getQuizzes();
    },
    async runAI(model){
      if(this.selectedQuizzes.length < 1) {
        return this.$toast.error("Please select quiz first");
      }
      let quizSelectData = { 
        "quizIds": this.selectedQuizzes,
        "modalType": model,
        "open_ai_params": {
            "temperature": 1,
            "top_p": 1
        }
      };
      this.$toast("AI Job started");
      try {
        const res = await quizService.runQuizAI(quizSelectData);
        if(res.data && res.data.success) {
          this.$toast.success("AI Job Completed successfully");
        } else {
          this.$toast.error("AI Job Failed");
        }
      } catch (error) {
        this.$toast.error("AI Job Error " + error.message);
      }
    },
    
    // Method to get the back link with keepFilters parameter if needed
    getBackLinkWithFilterParam() {
      if (this.keepFilters) {
        return {
          path: 'quiz-landing',
          query: { keepFilters: 'true' }
        };
      } else {
        return {
          path: 'quiz-landing'
        };
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.keepFilters) {
      localStorage.setItem('quizFilterAndSort', JSON.stringify(this.filterAndSort));
      
      // Only add keepFilters parameter if it's not already there
      if (to.query.keepFilters !== 'true') {
        const query = { ...to.query, keepFilters: 'true' };
        next({ 
          path: to.path,
          query: query,
          hash: to.hash,
          name: to.name,
          params: to.params
        });
      } else {
        next();
      }
    } else {
      // Remove keepFilters from localStorage and don't add to URL
      localStorage.removeItem('quizFilterAndSort');
      next();
    }
  },
  mounted() {
    this._isMounted = true;
    
    // Clear any cached data on page load
    if (!this._initialLoadComplete) {
      this.quizzes = [];
    }
    
    // Add event listener for page refresh
    window.addEventListener('beforeunload', () => {
      // If we're not keeping filters, clear localStorage
      if (!this.keepFilters) {
        localStorage.removeItem('quizFilterAndSort');
      }
    });
  },
  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('beforeunload');
  }
};
</script>

<style src="./quiz-landing.css" scoped></style>